module.exports = __webpack_public_path__ + "images/stickers/residue.98ba01532da369b380d1.png";